import { useEffect, useState } from "react";
import { fetchContent } from "@/lib/api";

export const CONTENT_DEFAULTS = {
    contact_email: "bomgay.admin@gmail.com",
    hero_intro:
        "Queer life is made of the stories we tell, the histories we inherit and the desires that shape us. BOMGAY documents LGBTQIA+ life through intimate conversations, oral histories and cultural inquiry. Rooted in Bombay, connected to South Asia, and open to the world.",
    host_bio_1:
        "Sagar Malkar is a filmmaker, media entrepreneur and storyteller interested in the intersections of culture, identity, law and lived experience.",
    host_bio_2:
        "Through BOMGAY, he brings people together for candid conversations about queer life, its histories, contradictions, intimacies and possibilities.",
    host_bio_3:
        "His approach combines cultural curiosity with a belief that the stories we tell about ourselves deserve to be heard, remembered and passed on.",
};

export function useContent() {
    const [content, setContent] = useState({
        settings: CONTENT_DEFAULTS,
        press_assets: [],
    });

    useEffect(() => {
        fetchContent()
            .then((d) =>
                setContent({
                    settings: { ...CONTENT_DEFAULTS, ...d.settings },
                    press_assets: d.press_assets || [],
                })
            )
            .catch(() => {});
    }, []);

    return content;
}
